import { ImageEditorModal } from '@/components/commons/imageEditor/EditorImageModal'
import { useContext, useState } from 'react'
import { useIsOwnProfile, useProfile } from '../../hooks/useProfile'
import { BrowserContext } from 'context'
import { IMAGE_PATHS_V2 } from '@/shared/consts/imagesPaths'
import { uploadUserImage } from '@/services/user'
import { Cover } from 'containers/recommendations/Cover'
import { useUpdateUser } from 'containers/user/hooks/useUser'
import { useProfileStore } from 'containers/profile/store/profile'

const coverWidthMobile = 330
const coverWidthTablet = 440
const coverWidthDesktop = 500

export const CoverProfile = () => {
  const { profile, isLoading } = useProfile()
  const { setProfile } = useProfileStore()
  const ownProfile = useIsOwnProfile()
  const { mutateAsync: updateUser } = useUpdateUser()

  const { isMobile, isTablet } = useContext(BrowserContext)

  const [openEditor, setOpenEditor] = useState(false)

  const handleEditorModal = (state: boolean) => {
    if (!ownProfile) return

    const checklist = document.querySelector('#profile-onboarding-checklist')

    if (checklist) {
      const classList = checklist.classList

      state ? classList.add('hidden') : classList.remove('hidden')
    }

    setOpenEditor(state)
  }

  const coverImage =
    profile?.coverImage ||
    profile?.converImage ||
    IMAGE_PATHS_V2.profileDemo + 'cover_image.png'

  const processImage = async (image) => {
    setProfile({
      ...profile,
      converImage: image,
      coverImage: image,
    })
    await updateUser({
      converImage: image,
      coverImage: image,
    })
  }

  const getHeightFromWidth = (width: number) => {
    // return aspect ratio of 1080/
    return width / 3.5557
  }

  return (
    <>
      {ownProfile && (
        <ImageEditorModal
          title="Edit Your Profile Cover Image"
          subtitle="Cover Image Size = 1080 × 180"
          showModal={ownProfile && openEditor}
          closeModal={() => handleEditorModal(false)}
          originalImage={coverImage}
          onSaveImage={processImage}
          primaryButtonlabel="Update Cover Pic"
          width={
            isMobile
              ? coverWidthMobile
              : isTablet
              ? coverWidthTablet
              : coverWidthDesktop
          }
          height={
            isMobile
              ? getHeightFromWidth(coverWidthMobile)
              : isTablet
              ? getHeightFromWidth(coverWidthTablet)
              : getHeightFromWidth(coverWidthDesktop)
          }
          serviceUpload={uploadUserImage}
          key={'cover_image_editor'}
          imageContainerWidth={'100%'}
          aspectRatio="16/3.5557"
        />
      )}
      <Cover
        src={coverImage}
        alt={'cover_profile_' + profile?.username}
        showEditButton={ownProfile}
        className={ownProfile && 'cursor-pointer'}
        onClick={() => handleEditorModal(true)}
        loading={isLoading}
      />
    </>
  )
}
